import { OrderStatus } from './arrival';
import { AlertType } from './hasRecommendOrders';
import { UserAccount } from './users';

/**
 * 分納
 */
export type PartialDelivery = {
  /**
   * 分納ID
   */
  id: string;
  /**
   * 組織ID
   */
  organizationId: string;
  /**
   * 親の発注ID
   */
  orderId: string;
  /**
   * 親の集計ID
   */
  aggregateBusinessId: string;
  /**
   * ユーザーが設定する発注番号
   */
  partialDeliveryNumber: string;
  /**
   * 発注が作成された日時（Unixタイムスタンプ）
   */
  orderCreationTime: number;
  /**
   * 納期（Unixタイムスタンプ）
   */
  deliveryDate: number;
  /**
   * 発注数量
   */
  orderAmount: number;
  /**
   * 分納の発注ステータス
   */
  orderStatus: OrderStatus;
  /**
   * アラートに使用する在庫不足フラグ
   */
  isOutOfStockExpected: boolean;
  /**
   * 最終更新者
   */
  lastUpdatedByUser: UserAccount;
  /**
   * アラート
   */
  orderAlert: AlertType[];
  /**
   * レコードの作成日時（Unixタイムスタンプ）
   */
  createdAt: number;
  /**
   * レコードの最終更新日時（Unixタイムスタンプ）
   */
  updatedAt: number;
};

/**
 * 分納の型ガード
 * @param arg - 分納かどうか不明な値
 */
export const isPartialDelivery = (arg: any): arg is PartialDelivery => {
  return (
    arg.id !== undefined &&
    arg.organizationId !== undefined &&
    arg.orderId !== undefined &&
    arg.aggregateBusinessId !== undefined &&
    arg.partialDeliveryNumber !== undefined &&
    arg.orderCreationTime !== undefined &&
    arg.deliveryDate !== undefined &&
    arg.orderAmount !== undefined &&
    arg.orderStatus !== undefined &&
    arg.isOutOfStockExpected !== undefined &&
    arg.lastUpdatedByUser !== undefined &&
    arg.orderAlert !== undefined &&
    arg.createdAt !== undefined &&
    arg.updatedAt !== undefined
  );
};
